import { PaginationResponse } from '@ready/dashboardv2api.contracts';
import { IBulkEditMenu, IBulkEditMenuRequest } from '@ready/menu.core';
import { IPagedResponse } from '@ready/table.core';
import config from 'config';
import executeApiAsync from 'services/utils/executeApiAsync';
import toPaginationResponse from 'services/utils/toPaginationResponse';
import { undefinedWithNullReplacer } from 'utils/objectUtils/replaceUndefinedWithNull';
import { objectToQueryParamsString } from 'utils/urlUtils/objectToQueryParamsString';

export const getLocationMenus = async (
  companyId: string,
  menuId: string,
  page: number = 1,
  pageSize: number = 50,
  searchTerm?: string
): Promise<PaginationResponse<IBulkEditMenu>> => {
  const queryString = objectToQueryParamsString({
    pageNumber: page.toString(),
    pageSize: pageSize.toString(),
    lq: searchTerm,
  });

  const url = `${config.readyDashboardApiEndpoint}/companies/${companyId}/menus/${menuId}/locationMenus?${queryString}`;
  const { results, totalCount } = await executeApiAsync<IPagedResponse<IBulkEditMenu>>(`${url}`, {
    method: 'GET',
  });

  return toPaginationResponse({ results, totalCount }, page, pageSize);
};

export const saveLocationMenus = async (
  companyId: string,
  menuId: string,
  updates: Omit<IBulkEditMenuRequest, 'templateMenuId'>
): Promise<void> => {
  const url = `${config.readyDashboardApiEndpoint}/companies/${companyId}/menus/${menuId}/locationMenus`;

  return await executeApiAsync(url, {
    method: 'PUT',
    body: JSON.stringify(updates, undefinedWithNullReplacer),
  });
};
